// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    /* text colors */
    --text-color-1: #83a4cf;
    --text-color-2: #0E3157;
    --text-color-3: #fff;
    /* bg-colors */
    --primary-bg-color: #f8f9fa;
    --card-bg-color: #CDDAEA;
    /* --badge-color:var(--text-color-1) */

}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/BatteryDigitalTwin_Bus/BDT_global.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,oBAAoB;IACpB,cAAc;IACd,2BAA2B;IAC3B,wBAAwB;IACxB,sCAAsC;;AAE1C","sourcesContent":[":root {\n    /* text colors */\n    --text-color-1: #83a4cf;\n    --text-color-2: #0E3157;\n    --text-color-3: #fff;\n    /* bg-colors */\n    --primary-bg-color: #f8f9fa;\n    --card-bg-color: #CDDAEA;\n    /* --badge-color:var(--text-color-1) */\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
